import { v4 as uuidv4 } from 'uuid';
import { v5 as uuidv5 } from 'uuid';
import { ObjID } from 'src/app/interfaces/object-id.interface';

const UUID_NAMESPACE = '3360dfe9-a8b8-441c-b466-fbb7f0ed8a35';

export function getUUID(seed?: string): ObjID {
	if (seed) {
		return uuidv5(seed, UUID_NAMESPACE);
	} else {
		return uuidv4();
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
